import graphql__b51cebcba77e0e7d981b from "./__generated__/ContributionBookmarkButton_contribution.graphql.js";import { useState } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import withAlert from "../../Alerts/withAlert";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "../../Alerts/Alert";
import Button from "../../Buttons/Button";
import { buttonWithAuthorization } from "../../buttonWithAuthorization";
import { useFormatMessage } from "../../Intl/Context";
import { isUnauthorized } from "../../Utils/authorizations";

import { updateContributionBookmark } from "../../../mutations/UpdateContributionBookmarkMutation";
import Tooltip from "../../Tooltip/Tooltip";

const ContributionBookmarkButton = props => {
  const contribution = useFragment(
    ContributionBookmarkButton_contribution,
    props.contribution
  );

  const {
    displayLabel,
    authenticate,
    showAlert,
    ignoreDefaultClassName,
    disabledAriaLabel
  } = props;

  const { isBookmarked } = contribution;
  const { bookmarksCreationAuthorized } = contribution.authorizations;

  const [isSubmitting, setIsSubmitting] = useState(false);

  const t = useFormatMessage();
  const labels = {
    add: t(intlMessages.add),
    remove: t(intlMessages.remove)
  };

  const buttonLabelText = isBookmarked ? labels.remove : labels.add;
  const buttonLabel = displayLabel === false ? null : buttonLabelText;
  const ariaLabel = disabledAriaLabel ? {} : { "aria-label": buttonLabelText };

  const className = classNames([
    {
      "btn btn-primary-inverse btn-sm box-shadow": !ignoreDefaultClassName
    },
    props.className
  ]);

  const handleClick = () => {
    authenticate(handleUserAuthenticated);
  };

  const handleUserAuthenticated = () => {
    setIsSubmitting(true);

    updateContributionBookmark(contribution, !isBookmarked, handleBookmarkResponse);
  };

  const handleBookmarkResponse = ({ updateContributionBookmark }) => {
    const { notice, success } = updateContributionBookmark;
    setIsSubmitting(false);

    showAlert({
      message: notice,
      type: success ? ALERT_TYPE_SUCCESS : ALERT_TYPE_ERROR
    });
  };

  const iconClassName = classNames("icon-featured", {
    "text-primary-inverse": !isBookmarked,
    "text-shadow-primary": !isBookmarked,
    "text-primary": isBookmarked
  });

  if (isUnauthorized(bookmarksCreationAuthorized)) return null;

  // Note : The tooltip is only shown when the button has no visible label, as it's
  //        useless to show the same information twice.
  return (
    <Tooltip show={!buttonLabel} content={buttonLabelText}>
      <Button
        type="button"
        className={className}
        onClick={handleClick}
        disabled={isSubmitting}
        data-loading={isSubmitting}
        label={buttonLabel}
        iconClassName={iconClassName}
        iconPosition="after"
        {...ariaLabel}
      />
    </Tooltip>
  );
};

const ContributionBookmarkButton_contribution = graphql__b51cebcba77e0e7d981b;

export default buttonWithAuthorization(withAlert(ContributionBookmarkButton));

const intlMessages = defineMessages({
  add: {
    id: "contributions.bookmark.add",
    defaultMessage: "Ajouter à mes favoris"
  },
  remove: {
    id: "contributions.bookmark.remove",
    defaultMessage: "Retirer de mes favoris"
  }
});
